<template>
  <div class="list-item" :class="[imgPosotion, {'theme-item': info.ctype == 1 || info.is_promotion}]">
    <div class="image" @click="routeArticle" v-if="info.article_cover || !nullImage" :data-icon="imageIconLabel">
      <img class="book-image" :src="info.article_cover | image({resize:{h: 400}})" :alt="info.article_title" v-if="info.type == 8" />
      <template v-else>
        <ArticleImage
          :src="info.article_cover"
          :info="info.article_cover_point"
          :width="image.width"
          :height="image.height"
          :size="image.size"
          :alt="info.article_title"
          v-if="info.article_cover"
        />
        <img class="placeholder-image" src="../../assets/img/article-placeholder-image.jpg" :alt="info.article_title" v-else />
      </template>
      <slot name="image" />
    </div>
    
    <div class="info">
      <div class="iconfont favorite-icon" :class="{favorited: isFavorite}" v-if="favorite" @click="toggleFavorite">
        {{isFavorite ? '&#xe630;' : '&#xe62e;'}}
      </div>
      <div class="recommond" v-if="recommond && info.recommond">
        根据关注的
        <AuthorName :uid="info.recommond.uid" :name="info.recommond.nickname" v-if="info.recommond.uid" />
        <TopicTitle :id="info.recommond.id" :title="info.recommond.name" v-else />
        {{info.recommondLength > 1 ? '等' : ''}}推荐
      </div>
      <h6 :class="{favorite: favorite, 'with-recommond': recommond && info.recommond, 'with-image': info.article_cover}">
        <ArticleTitle :uuid="info.uuid || info.aid" :title="info.article_title" :type="articleType" />
      </h6>

      <template v-if="summary">
        <p class="summary" :class="{'with-recommond': recommond && info.recommond}" v-html="info.article_rich_summary" v-if="info.article_rich_summary" />
        <p class="summary" :class="{'with-recommond': recommond && info.recommond}" v-else>{{info.article_summary | formatContent}}</p>
      </template>


      <p class="editor" :class="{'with-image': info.article_cover}" v-if="author">
        <template v-if="info.no_author">{{info.no_author}}</template>
        <template v-else>
          <template v-if="info.author && info.author.length">
            <!-- 不在有 出品人这个  类型之后 不用判断ctype 了 -->
            <!-- {{info.ctype == 1 ? '出品人' : '作者'}}: -->
            作者:
            <AuthorName
              class="author"
              v-for="author in info.author"
              :uid="author.uid"
              :name="author.nickname"
              :follow="follow"
              :key="`a${author.uid}`"
            />
          </template>
          <!-- <template v-else>
            <span class="author" style="cursor:default">
              佚名
            </span>
          </template> -->
        </template>
        
        <span class="placeholder" v-if="info.author && info.author.length && info.translator"></span>
        <template v-if="info.translator">
          译者: 
        </template>
        <span class="translators">
          <AuthorName
            class="translator"
            v-for="translator in info.translator"
            :uid="translator.uid"
            :name="translator.nickname"
            :follow="follow"
            :key="`a${translator.uid}`"
          />
        </span>
        
        <!-- 策划人作者类型 -->
        <span class="placeholder" v-if="(info.author && info.author.length || info.translator) && info.planner"></span>
        <template v-if="info.planner">
          策划: 
        </template>
        <AuthorName
          class="planner"
          v-for="planner in info.planner"
          :uid="planner.uid"
          :name="planner.nickname"
          :follow="follow"
          :key="`a${planner.uid}`"
        />
      </p>
      <div class="extra" v-if="info.ctype != 1 && (topic || date)">
        <template v-if="topic">
          <TopicTag class="topic" :list="info.topic"  v-if="!inTopicPage || !isMobile" />
          <TopicTitle class="topic-lonely" :id="info.topic[0].id" :title="info.topic[0].name" v-else />
        </template>
        <div class="date" v-if="date">
          {{info.publish_time || info.ctime | date('near', 'YYYY 年 M 月 D 日')}}
        </div>
      </div>
      <slot name="info" />
    </div>

    <slot />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import vueTypes from 'vue-types'

import ArticleImage from '../../components/list/ArticleImage'
import ArticleTitle from '../../components/title/ArticleTitle'
import AuthorName from '../../components/title/AuthorName'
import TopicTitle from '../title/TopicTitle'
import FollowPopup from './FollowPopup'
import TopicTag from './TopicTag'

import ArticleService from '../../service/article.service'

export default {
  name: 'list-item',
  components: {
    ArticleImage,
    ArticleTitle,
    AuthorName,
    TopicTitle,
    FollowPopup,
    TopicTag
  },
  props: {
    /**
     * 文章数据
     */
    info: vueTypes.object.def({}),
    /**
     * 允许不包含图片
     */
    nullImage: vueTypes.bool.def(true),
    /**
     * 图片信息
     * @param {String} position 图片位置 [left, right, top]
     * @param {Number} width    图片宽度
     * @param {Number} height   图片高度
     * @param {String} size     图片尺寸 [big, small]
     */
    image: vueTypes.object.def({}),
    /**
     * 图片的所在位置
     */
    position: vueTypes.string.def('left'),
    /**
     * 是否展示推荐来源
     */
    recommond: vueTypes.bool.def(false),
    /**
     * 是否使用收藏功能
     */
    favorite: vueTypes.bool.def(false),
    /**
     * 是否使用关注作者功能
     */
    follow: vueTypes.bool.def(false),
    /**
     * 是否展示摘要
     */
    summary: vueTypes.bool.def(false),
    /**
     * 是否展示日期
     */
    date: vueTypes.bool.def(false),
    /**
     * 是否展示频道
     */
    topic: vueTypes.bool.def(true),
    /**
     * 是否在频道详情页
     * 在频道详情页的 组件 不适用 TopicTag 组件, 取第一个频道
     */
    inTopicPage: vueTypes.bool.def(false),
    /**
     * 是否展示作者信息
     */
    author: vueTypes.bool.def(false)
  },
  data () {
    return {
      topicWidth: 0,
      followPopupKey: '',
      isFavorite: this.info.is_collect
    }
  },
  computed: {
    ...mapState(['isMobile']),
    imgPosotion () {
      const position = this.image.position || this.position

      switch (position) {
        case 'main':
          return 'image-position-main'
        case 'left':
          return 'image-position-left'
        case 'right':
          return 'image-position-right'
        case 'top':
          return 'image-position-top'
        default:
          return ''
      }
    },
    imageIconLabel () {
      return this.info.ctype === 1 ? '专题' : this.info.is_promotion ? '推广' : ''
    },
    /**
     * 内容类型 [0:文章,1:专题,2:话题]
     */
    articleType () {
      return this.info.ctype === 1 ? 1 : this.info.sub_type === 1 ? 2 : 0
    },
    /**
     * 是否是话题
     */
    isTalk () {
      return this.articleType === 2
    },
    url () {
      let type = 'article'

      switch (this.articleType | 0) {
        case 0:
          type = 'article'
          break
        case 1:
          type = 'theme'
          break
        case 2:
          type = 'talk'
          break
        default:
          break
      }

      return `/${type}/${this.info.uuid || this.info.aid}`
    },
    articleTypeLabel () {
      let type = 'article'

      switch (this.articleType | 0) {
        case 0:
          type = 'article'
          break
        case 1:
          type = 'theme'
          break
        case 2:
          type = 'talk'
          break
        default:
          break
      }
      return type
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    /**
     * 收藏/取消收藏文章
     */
    toggleFavorite () {
      !this.isFavorite && window.ga && window.ga('send', 'event', '文章新增收藏数', `${this.articleTypeLabel}-list`)

      ArticleService.favoriteArticle(this.info.aid, !this.isFavorite).then(res => {
        this.isFavorite = !this.isFavorite
      })
    },
    /**
     * 跳转到文章详情页
     */
    routeArticle () {
      window.open(this.url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.list-item {
  position: relative;
  display: flex;
}
.image {
  overflow: hidden;
  @extend %center;
  border-radius: 4px;
  cursor: pointer;

  &:hover img {
    transform: scale(1.2);
  }

  & img {
    display: block;
    border-radius: 3px;
    @extend %transition;
  }
}
.theme-item .image {
  position: relative;

  @include themeIcon(10px, 10px, 1);
}
.info {
  position: relative;
  display: flex;
  flex-direction: column;

  & .iconfont.favorite-icon {
    position: absolute; right: -1px; top: -5px; z-index: 1;
    @include font(24, 400);
    color: #D8D9DE;
    @extend %transition;
    cursor: pointer;
    user-select: none;

    &.favorited {
      color: $green;
    }
  }

  & h6 {
    @include font(18, 400);

    & span,
    & a {
      @extend %animateFontBlack;
    }
  }
}
.recommond {
  position: relative;
  padding-left: 27px;
  @extend %font12;
  @include row(1);
  color: $gray;

  &:before {
    content: '荐';
    display: block;
    position: absolute; left: 0; top: 2px;
    width: 18px; height: 16px;
    background: $blue;
    border-radius: 4px 4px 0 4px;
    line-height: 16px;
    text-align: center;
    color: #FFF;
  }

  & span {
    color: $blue;
  }
}

.editor {
  @extend %font12;
  color: $gray;

  & .placeholder {
    display: inline-block;
    position: relative;
    width: 1px; height: 9px;
    margin: 0 5px;
    background: #CFCFCF;
  }
}
.author {
  position: relative;
  cursor: pointer;

  &:before {
    content: ', ';
  }

  &:first-child:before {
    content: ' ';
  }

  & span {
    @extend %animateFontHover;
  }
}
.translator {
  position: relative;
  cursor: pointer;

  &:after {
    content: ' ,';
  }

  &:last-child:after {
    display: none;
  }

  & span {
    @extend %animateFontHover;
  }
}
.planner {
  position: relative;
  cursor: pointer;

  &:after {
    content: ' ,';
  }

  &:last-child:after {
    display: none;
  }

  & span {
    @extend %animateFontHover;
  }
}
.summary {
  // text-align: justify;
  @extend %font12;
  color: $gray;

  & ::v-deep em {
    color: $blue;
  }
}
.extra {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.topic {
  flex: 1;
}
.topic-lonely {
  @extend %font12;
  color: $gray;
}
.date {
  margin-left: $gridSpace;
  @include lineFont(12, 400);
  color: $gray;
}

/*
 * 图片在左面的样式
 */
.image-position-left {
  justify-content: space-between;

  & .image,
  & .info {
    width: $gridCol4;
  }

  & .info h6 {
    height: 52px;
    margin-top: -4px;
    line-height: 26px;
    @include row(2);
  }

  .editor {
    margin-top: 7px;
    @include row(2);
  }
  .extra {
    position: absolute; left: 0; bottom: 0; right: 0;
  }
  .summary {
    padding-top: 7px;
    height: 72px;
    @include row(3);
    line-height: 24px;
    @include font(14, 400);
  }
}

/*
 * 图片在右面的样式
 */
.image-position-right {
  justify-content: space-between;
  align-items: stretch;
  height: 156px;

  & .image {
    order: 1;
  }

  & .info {
    margin-top: -4px;

    & h6 {
      min-height: 26px; max-height: 52px;
      line-height: 26px;
      @include row(2);

      &.favorite {
        padding-right: 30px;
      }

      &.with-recommond {
        // height: 26px;
        max-height: 52px;
        @include row(2);
      }
    }

    & .summary {
      &.with-recommond {
        height: 24px;
        @include row(1);
      }
    }
  }

  .editor {
    height: 20px;
    @include row(1);
    margin-bottom: 5px;
  }

  & .recommond {
    padding-bottom: 4px;
  }

  & .summary {
    height: 48px;
    padding-top: 5px;
    @include row(2);
    line-height: 24px;
    @include font(14, 400);
  }

  & .extra {
    position: absolute; left: 0; bottom: 0;
    width: 100%;
  }

  // & .date .author {
  //   padding-right: 26px;

  //   &:after {
  //     overflow: hidden;
  //     content: ' ';
  //     display: block;
  //     position: absolute; right: 13px; top: 3px;
  //     width: 1px; height: 9px;
  //     background: $gray;
  //   }
  // }
}

/*
 * 图片在上面的样式
 */
.image-position-top {
  flex-direction: column;

  & .image {
    background: #EAEAEA;
  }

  & .image,
  & .info {
    width: 100%;
  }

  & .image img {
    width: 210px; height: 156px;

    &.book-image {
      width: auto; height: 120px;
    }

    &.placeholder-image {
      width: auto;
    }
  }

  & .info {
    margin-top: 18px;

    & h6 {
      height: 48px;
      line-height: 24px;
      @include row(2);
      @include font(16, 400);
    }
  }

  .editor {
    height: 40px;
    margin-top: 7px;
    @include row(2);
  }
  .extra {
    margin-top: 10px;
  }
}
@media screen and (max-width: 768px){
  .image-position-top {
    &.list-item {
      margin: 0 20px 20px 20px;
      width: 100%;
    }

    & .image {
      background: transparent;
    }

    & .image img {
      width: 100%; height: auto;

      &.book-image {
        height: 200px;
      }

      &.placeholder-image {
        width: 100%; height: auto;
      }
    }
  }
  .image-position-right {
    justify-content: space-between;
    height: auto;

    & .info {
      margin-top: -2px;

      & h6 {
        height: 48px;
        margin-top: -2px;
        line-height: 24px;
        @include font(16, 400);
        @include row(2);

        &.favorite {
          padding-right: 26px;
        }
        &.with-image {
          height: 48px;
        }
        &.with-recommond {
          height: 48px;
          margin-top: 0;
          @include row(2);
        }
      }

      & .recommond {
        padding: 0 0 0 22px;

        &:before {
          content: '荐';
          display: block;
          position: absolute; left: 0; top: 2px;
          width: 16px; height: 16px;
          line-height: 16px;
        }
      }

      & .editor {
        position: static;
        padding-top: 5px; margin-bottom: 0;
        @include row(1);

        &.with-image {
          position: absolute; left: 0; bottom: -4px;
          padding-top: 0;
        }
      }
    }
  }
}
</style>
